<div class="modal" [ngStyle]="{'display': visible}" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
  aria-hidden="true">
  <div class="modal-backdrop fade in" style="height: 2607px;"></div>
  <div class="modal-dialog modal-lg">
    <div class="modal-content" style="border-radius: 7px;">
      <div class="modal-header"
        style="color:white;line-height: 0.5;border-bottom: 1px solid var(--brand-primary-color);background: var(--brand-primary-color);border-top-right-radius: 7px;border-top-left-radius: 7px;">
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
        <div class="modal-title" style="font-weight: 500">
          <span style="margin-left: 10px;">{{ 'update' | translate }} <b>{{studentName}}</b> {{ 'basicInfo' | translate }}</span>
        </div>
      </div>
      <div class="modal-body" style="height: 400px;overflow-y: scroll">
        <!-- student basic info -->
        <form [ngStyle]="{'display': showClassChangeWarning ? 'none' : 'block'}" class="form student-detail-summary">
          <div class="row" style="margin: 0;">
            <div class="col-md-3" style="margin-top: 1em;text-align: center;">
              <div class="cropme-student-edit student-image" id="myimage"
                style="width: 150px;min-height: 150px;float: initial;margin: 0 auto;border: 1px dashed  #e0e0e0;text-align: center;">
                <a [href]="studentData.studentImage" target="_blank" class="cursor-pointer" aria-expanded="true">
                  <img class="img-responsive student-image" src="{{studentData.studentImage}}" id="selected-image"></a>
              </div>
              <div class="col-md-12" style="text-align:center;">
                <div class="col-md-12" style="text-align:center;">
                  <h5 class="progress hide" id="editStudent-progressbar"
                    style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                    {{ 'uploading' | translate }}</h5>
                </div>
                <input name="profilePic" id="selectProfilePic" (change)="editStudentProfilePic($event)" type="file"
                  class="input-style" accept="image/*" style="width:1px; height: 1px">
                <h5 (click)="triggerSelectProfilePic()" class="image-edit"
                  style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 5px 0px;margin: 1em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 131px;">
                  {{ 'updateStudentImage' | translate }}</h5>
                <i class="fas fa-trash cursor-pointer" style="color: #F44336;" data-toggle="modal"
                  data-target="#deletePopup" *ngIf="studentData.studentImage"></i>
              </div>
            </div>
            <div class="col-md-9">
              <h5>{{ 'basicInfo' | translate }}: &nbsp; <i *ngIf="profileIsLoading" class="fa fa-spinner fa-spin" aria-hidden="true"
                  style="vertical-align: middle"></i></h5>
            </div>
            <div class="col-md-5">
              <div class="form-group">
                <input id="edit-student-name" name="studentName" [(ngModel)]="studentData.studentName" type="text"
                  class="form-control">
                <label for="edit-student-name">{{ 'name' | translate }}<span style="color: #F44336;">*</span></label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <input id="edit-student-surname" name="surname" [(ngModel)]="studentData.surname" type="text"
                  class="form-control" #editstudentSurname>
                <label for="edit-student-surname">{{ 'surname' | translate }}</label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <input id="edit-student-email" name="studentEmail" [(ngModel)]="studentData.studentEmail" type="text"
                  class="form-control" #editstudentStudentEmail>
                <label for="edit-student-email">{{ 'studentEmail' | translate }}</label>
              </div>
            </div>
            <div class="col-md-5">
              <div class="form-group mobile-number-container">
                <input type="text" id="edit-student-number" class="form-control" #editStudentContactNumber
                  [ngModelOptions]="{standalone: true}" [ngClass]="{
                      'edit-student-mobile-number': !invalidEditStudentMobileNumber,
                      'edit-student-mobile-number-error': invalidEditStudentMobileNumber
                    }" (input)="handleDebounceEditStudentMobileNumber(editStudentContactNumber)"
                   maxlength="20" placeholder="Enter contact number"
                  [(ngModel)]="editSelectedStudentContact" value="{{editSelectedStudentContact}}"
                  (keydown)="handleKeyDown($event)" autocomplete="off" />
                <label for="edit-student-number">{{ 'studentContact' | translate }}</label>
              </div>
            </div>
          </div>
          <div class="row" style="margin: 0;">
            <div class="col-md-3">
              <div class="form-group">
                <input name="dateOfAdmission" id="new-edit-student-admissiondate" type="text" class="form-control"
                  [(ngModel)]="studentData.dateOfAdmission" data-provide="datepicker" data-date-format="dd/mm/yyyy"
                  data-date-end-date="0d">
                <label for="edit-student-admissiondate">{{ 'admisssionDate' | translate }}<span style="color: #F44336;">*</span></label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <input id="edit-student-admissionnum" name="registrationId" [(ngModel)]="studentData.registrationId"
                  type="text" class="form-control">
                <label for="edit-student-admissionnum">{{ 'admissionNumber' | translate }}<span style="color: #F44336;">*</span></label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <input type="text" id="basic-edit-student-dob" name="dateOfBirth" [(ngModel)]="studentData.dateOfBirth"
                  class="form-control" data-provide="datepicker" data-date-format="dd/mm/yyyy" data-date-end-date="0d">
                <label for="edit-student-dob">{{ 'dateOfBirthDd/mm/yyyy' | translate }}<span style="color: #F44336;">*</span></label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>{{ 'gender' | translate }}<span style="color: #F44336;">*</span></label>
                <div class="row" style="margin-top: 12px;width: 100%;">
                  <label class="radio-inline radio-styled">
                    <input type="radio" [(ngModel)]="studentData.gender" id="edit-student-genderMale" class="gender"
                      (change)="onGenderChange()" name="gender" [value]="1"><span>{{ 'male' | translate }}</span>
                  </label>
                  <label class="radio-inline radio-styled">
                    <input type="radio" [(ngModel)]="studentData.gender" id="edit-student-genderFemale" class="gender"
                      name="gender" (change)="onGenderChange()" [value]="0"><span>{{ 'female' | translate }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin: 0;">
            <!--Class Section-->
            <div class="col-md-3">
              <div class="form-group">
                <select (change)="onChangeEditStudentCategory()" name="categoryId" [(ngModel)]="studentData.categoryId"
                  class="form-control catId" style="text-transform: uppercase;border: 1px solid #e2e2e2;"
                  id="edit-student-categoryId">
                  <option [value]="null">{{ 'none' | translate }}</option>
                  <option *ngFor="let category of categoryList" [value]="category.categoryId">{{category.categoryName}}
                  </option>
                </select>
                <label for="edit-student-categoryId">{{ 'category' | translate }}<span style="color: #F44336;">*</span></label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <select (change)="onChangeEditStudentClass()" name="classStandardId"
                  [(ngModel)]="studentData.fkClassStandardsId" class="form-control"
                  style="text-transform: uppercase;border: 1px solid #e2e2e2;" id="edit-student-classId">
                  <option [value]="null">{{ 'none' | translate }}</option>
                  <option *ngFor="let standard of classStandardsList" [value]="standard.pkClassStandardsId">
                    {{standard.ClassStandard}}</option>
                </select>
                <label for="edit-student-classId">{{ 'class' | translate }}<span style="color: #F44336;">*</span></label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <select id="edit-student-section" name="classId" (change)="onChangeEditStudentSection()"
                  [(ngModel)]="studentData.classId" class="form-control"
                  style="text-transform: uppercase;border: 1px solid #e2e2e2;">
                  <option [value]="null">{{ 'none' | translate }}</option>
                  <option *ngFor="let section of sectionList" [value]="section.classId">{{section.classNumber}} -
                    {{section.classDivision}}</option>
                </select>
                <label for="edit-student-section">{{ 'section' | translate }}<span style="color: #F44336;">*</span></label>
              </div>
            </div>
            <!--End Class Section-->
            <div class="col-md-3">
              <div class="form-group">
                <input name="stdRoll" id="edit-student-rollNumber" [(ngModel)]="studentData.rollNumber" type="text"
                  class="form-control">
                <label for="edit-student-rollNumber">{{ 'classIdRollNumber' | translate }}<span
                    style="color: #F44336;">*</span></label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <input name="admittedClass" id="student-admitted-class" [(ngModel)]="admittedClassYear" type="text"
                  class="form-control disabled">
                <label for="student-admitted-class">{{ 'admittedClassAcademic' | translate }}</label>
              </div>
            </div>
            <div class="col-md-3" *ngIf="houseNameList.length > 0">
              <div class="form-group">
                <select [(ngModel)]="studentData.houseName" id="edit-student-housename" name="edit-student-housename"
                  class="form-control" style="text-transform: uppercase;border: 1px solid #e2e2e2;">
                  <option [value]="null">{{ 'none' | translate }}</option>
                  <option *ngFor="let house of houseNameList" [value]="house.houseName">{{house.houseName}}</option>
                </select>
                <label for="edit-student-section">{{ 'houseName' | translate }}</label>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <input id="edit-student-pen-number" name="penNumber" [(ngModel)]="studentData.penNumber" type="text"
                  class="form-control" maxlength="12" (keydown)="handleKeyDown($event)">
                <label for="edit-student-pen-number">{{ 'permanentEducationalNumber(pen' | translate }}</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <input id="edit-student-aadharNumber" name="aadharNumber" [(ngModel)]="studentData.aadharNumber"
                  type="text" class="form-control" maxlength="12">
                <label for="edit-student-aadharNumber">{{ 'aadhar(uidNumber' | translate }}</label>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group" style="display: flex;">
                <div class="col-md-12 hide" style="text-align:center;" id="edit-student-aadhar-progressbar-div">
                  <h5 class="progress" id="edit-student-aadhar-progressbar"
                    style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                    {{ 'uploading' | translate }}</h5>
                </div>
                <button id="edti-student-aadhar-copy-button" style="margin-top: 5px;"
                  (click)="openEditStudentAadharCopyUpload()"
                  class="btn-raised ink-reaction form-control">{{ 'upload' | translate }}</button>
                <input (change)="startUploadingEditStudentAadharCopy($event)" style="width: 1px;height: 1px" type="file"
                  class="form-control hide" id="edit-student-aadhar-copy-basic">
                <a *ngIf="aadharReferenceFileType === 'application/pdf' && studentData.aadharCopy"
                  [href]="studentData.aadharCopy" target="_blank" class="cursor-pointer" aria-expanded="true">
                  <i class="fas fa-file-pdf" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
    font-size: 39px;"></i>
                </a>
                <a *ngIf="studentData.aadharCopy" [href]="studentData.aadharCopy" target="_blank" class="cursor-pointer"
                  aria-expanded="true"> <img
                    *ngIf="aadharReferenceFileType !== 'application/pdf' && studentData.aadharCopy"
                    id="edit-student-aadhar-image-ele" [src]="studentData.aadharCopy"
                    style="margin-left: 10px;width: 63px;height: 40px;margin-top: 3px;"> </a>
                <label for="edti-student-aadhar-copy-button">{{ 'aaadharCopy' | translate }}</label>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group" style="display: flex;">
                <label>{{ 'tcBirthCertificateSubmitted' | translate }}</label>
                <div class="" style="margin-top: 12px;width: 100%;">
                  <label class="radio-inline radio-styled">
                    <input type="radio" [(ngModel)]="studentData.tcOrBirthCertificateUploaded"
                      id="edit-student-tc-birth-yes" class="gender" name="tcOrBirthCertificateUploaded" [value]="1"
                      ><span>{{ 'yes' | translate }}</span>
                  </label>
                  <label class="radio-inline radio-styled">
                    <input type="radio" [(ngModel)]="studentData.tcOrBirthCertificateUploaded"
                      id="edit-student-tc-birth-no" class="gender" name="tcOrBirthCertificateUploaded" [value]="0"
                      ><span>{{ 'no' | translate }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group " style="display: flex;">
                <div class="col-md-12 hide" style="text-align:center;" id="edit-student-tc-birth-cert-progressbar-div">
                  <h5 class="progress" id="edit-student-tc-birth-cert-progressbar"
                    style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 9px 0px;margin: 1em -2em;color: var(--secondary-btn-bg-color);font-size: 9px;text-transform: uppercase;width: 150px;">
                    {{ 'uploading' | translate }}</h5>
                </div>
                <button id="edti-student-tc-birth-cert-button" style="margin-top: 5px;"
                  (click)="openEditStudentTcBirthCertUpload()"
                  class="btn-raised ink-reaction form-control">{{ 'upload' | translate }}</button>
                <input (change)="startUploadingEditStudentTcBirthCert($event)" style="width: 1px;height: 1px"
                  type="file" class="form-control hide" id="edit-student-tc-birth-cert-basic">
                <a *ngIf="tcOrBirthCertificateFileType === 'application/pdf' && studentData.tcOrBirthCertificate"
                  [href]="studentData.tcOrBirthCertificate" target="_blank" class="cursor-pointer" aria-expanded="true">
                  <i class="fas fa-file-pdf" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
    font-size: 39px;"></i>
                </a>

                <a *ngIf="studentData.tcOrBirthCertificate" [href]="studentData.tcOrBirthCertificate" target="_blank"
                  class="cursor-pointer" aria-expanded="true">
                  <img *ngIf="tcOrBirthCertificateFileType !== 'application/pdf' && studentData.tcOrBirthCertificate"
                    id="edit-student-aadhar-image-ele" [src]="studentData.tcOrBirthCertificate"
                    style="margin-left: 10px;width: 63px;height: 40px;margin-top: 3px;"> </a>
                <label for="edti-student-tc-birth-cert-button">{{ 'tcBirthCertificate' | translate }}</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group " style="display: flex;">
                <select [(ngModel)]="studentData.cast" id="admission-cast" name="selectCaste" class="form-control"
                  style="text-transform: initial;border: 1px solid #e2e2e2;margin-top: 5px;padding: 0px 10px;"
                  (change)="onCasteChange()">
                  <option value="General">{{ 'general' | translate }}</option>
                  <option value="OBC">{{ 'obc' | translate }}</option>
                  <option value="ST">{{ 'st' | translate }}</option>
                  <option value="SC">{{ 'sc' | translate }}</option>
                </select>
                <label for="admission-cast">{{ 'casteCategory' | translate }}</label>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group " style="display: flex;">
                <button id="edti-student-caste-cert-button" style="margin-top: 5px;"
                  (click)="openEditStudentCasteCertUpload()"
                  class="btn-raised ink-reaction form-control">{{ 'upload' | translate }}</button>
                <input (change)="startUploadingEditStudentCasteCert($event)" style="width: 1px;height: 1px" type="file"
                  class="form-control hide" id="edit-student-caste-cert-basic">
                <a *ngIf="casteCertificateFileType === 'application/pdf' && studentData.casteCertificate"
                  [href]="studentData.casteCertificate" target="_blank" class="cursor-pointer" aria-expanded="true">
                  <i class="fas fa-file-pdf" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
    font-size: 39px;"></i>
                </a>

                <a *ngIf="studentData.casteCertificate" [href]="studentData.casteCertificate" target="_blank"
                  class="cursor-pointer" aria-expanded="true">
                  <img *ngIf="casteCertificateFileType !== 'application/pdf' && studentData.casteCertificate"
                    [src]="studentData.casteCertificate" id="edit-student-caste-cert-image-ele"
                    style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;"> </a>
                <label for="edti-student-caste-cert-button">{{ 'casteCertificate' | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-12 ">
            <div>
              <div class="form-group " style="display: flex;">
                <div class="input-check-box-container">
                  <input class="check-box-input-filed" id="new-admission-minority" type="checkbox"
                    [checked]="studentData.isMinority" (change)="onMinorityChange($event)">
                  <label for="new-admission-minority" class="label-input-check-box">{{ 'minority' | translate }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="row" style="margin: 0;margin-top: 15px;">
            <div class="col-md-12">
              <h5>{{ 'whetherTheCandidateIs' | translate }}</h5>
            </div>
            <div class="col-md-12">
              <div class="col-md-3">
                <div class="edit-student-fee-input-check-box-container input-check-box-container">
                  <input class="check-box-input-filed" id="new-admission-minority" type="checkbox"
                    [checked]="studentData.isSpeciallyAbled" (change)="onIsSpeciallyAbledChange($event)">
                  <label for="new-admission-minority" class="label-input-check-box">{{ 'speciallyAbledDivyangjan' | translate }}</label>
                </div>
              </div>
              <div class="col-md-3" *ngIf="studentData.isSpeciallyAbled == '1'">
                <div class="form-group " style="display: flex;">
                  <button id="edti-student-specially-abled-button" style="margin-top: 5px;"
                    (click)="openEditStudentSpeciallyAbledCertUpload()"
                    class="btn-raised ink-reaction form-control">{{ 'upload' | translate }}</button>
                  <input (change)="startUploadingEditStudentSpeciallyAbledCert($event)" style="width: 1px;height: 1px"
                    type="file" class="form-control hide" id="edit-student-specially-abled-cert-basic">

                  <a *ngIf="speciallyAbledFileType === 'application/pdf' && studentData.speciallyAbledCertificate"
                    [href]="studentData.speciallyAbledCertificate" target="_blank" class="cursor-pointer"
                    aria-expanded="true">
                    <i class="fas fa-file-pdf" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
      font-size: 39px;"></i>
                  </a>
                  <a *ngIf="studentData.speciallyAbledCertificate" [href]="studentData.speciallyAbledCertificate"
                    target="_blank" class="cursor-pointer" aria-expanded="true">
                    <img src="{{studentData.speciallyAbledCertificate}}"
                      *ngIf=" speciallyAbledFileType !== 'application/pdf' && studentData.speciallyAbledCertificate"
                      id="edit-student-specially-abled-image-ele"
                      style="margin-left: 10px;width: 63px;height: 40px;margin-top: 3px;"> </a>
                  <label for="edti-student-specially-abled-button">{{ 'speciallyAbledCertificate' | translate }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-12" *ngIf="studentData.cast === 'General'">
              <div class="col-md-3 ">
                <div class="edit-student-fee-input-check-box-container input-check-box-container">
                  <input class="check-box-input-filed" id="new-admission-minority" type="checkbox"
                    [checked]="studentData.isEWSCategory" (change)="onIsEWSCategoryChange($event)">
                  <label for="new-admission-minority" class="label-input-check-box">{{ 'belongingToEwsEconomicallyWeakerSection' | translate }}</label>
                </div>
              </div>
              <div class="col-md-3" *ngIf="studentData.isEWSCategory == '1'">
                <div class="form-group " style="display: flex;">
                  <button id="edti-student-EWS-button" style="margin-top: 5px;" (click)="openEditStudentEWSCertUpload()"
                    class="btn-raised ink-reaction form-control">{{ 'upload' | translate }}</button>
                  <input (change)="startUploadingEditStudentEWSCert($event)" style="width: 1px;height: 1px" type="file"
                    class="form-control hide" id="edit-student-EWS-cert-basic">
                  <a *ngIf="ewsCertificateFileType === 'application/pdf' && studentData.ewsCertificate"
                    [href]="studentData.ewsCertificate" target="_blank" class="cursor-pointer" aria-expanded="true">
                    <i class="fas fa-file-pdf" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
      font-size: 39px;"></i>
                  </a>

                  <a *ngIf="studentData.ewsCertificate" [href]="studentData.ewsCertificate" target="_blank"
                    class="cursor-pointer" aria-expanded="true">
                    <img src="{{studentData.ewsCertificate}}"
                      *ngIf="ewsCertificateFileType !== 'application/pdf' && studentData.ewsCertificate"
                      id="edit-student-EWS-image-ele"
                      style="margin-left: 10px;width: 63px;height: 40px;margin-top: 3px;"></a>
                  <label for="edti-student-EWS-button">{{ 'ewsCertificate' | translate }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-12" *ngIf="studentData.gender == 0">
              <div class="col-md-3 ">
                <div class="edit-student-fee-input-check-box-container input-check-box-container">
                  <input class="check-box-input-filed" id="new-admission-minority" type="checkbox"
                    [checked]="studentData.isSingleGirlChild" (change)="onIsSingleGirlChildChange($event)">
                  <label for="new-admission-minority" class="label-input-check-box">{{ 'singleGirlChild' | translate }}</label>
                </div>
              </div>
              <div class="col-md-3" *ngIf="studentData.isSingleGirlChild == '1'">
                <div class="form-group " style="display: flex;">
                  <button id="edti-student-single-girl-button" style="margin-top: 5px;"
                    (click)="openEditStudentSingleGirlCertUpload()"
                    class="btn-raised ink-reaction form-control">{{ 'upload' | translate }}</button>
                  <input (change)="startUploadingEditStudentSingleGirlChildCert($event)" style="width: 1px;height: 1px"
                    type="file" class="form-control hide" id="edit-student-single-girl-cert-basic">
                  <a *ngIf="singleGirlChildCertificateFileType === 'application/pdf' && studentData.singleGirlChildCertificate"
                    [href]="studentData.singleGirlChildCertificate" target="_blank" class="cursor-pointer"
                    aria-expanded="true">
                    <i class="fas fa-file-pdf" style="margin-left: 10px; width: 63px; height: 40px; margin-top: 3px;  color: red;
      font-size: 39px;"></i>
                  </a>
                  <a *ngIf="studentData.singleGirlChildCertificate" [href]="studentData.singleGirlChildCertificate"
                    target="_blank" class="cursor-pointer" aria-expanded="true">
                    <img src="{{studentData.singleGirlChildCertificate}}"
                      *ngIf=" singleGirlChildCertificateFileType !== 'application/pdf' && studentData.singleGirlChildCertificate"
                      id="edit-student-single-girl-image-ele"
                      style="margin-left: 10px;width: 63px;height: 40px;margin-top: 3px;"> </a>
                  <label for="edti-student-single-girl-button">{{ 'singleGirlChildCertificate' | translate }}</label>
                </div>
              </div>

            </div>
          </div>
        </form>
        <div [ngStyle]="{'display': showClassChangeWarning ? 'block' : 'none'}">
          <br>
          <div class="col-md-12 text-center" style="border-style: ridge;border-color: red;">
            <div style="text-align: left;">{{ 'moving' | translate }} <b>{{studentName}}</b> {{ 'from' | translate }}
              <b>{{updateStudentClassChangeError.oldClassName}}</b> {{ 'to' | translate }}
              <b>{{updateStudentClassChangeError.newClassName}}</b> {{ 'notAllowed' | translate }}
            </div>
            <div style="text-align: left;"><b>{{ 'reason' | translate }}: </b>
              <div>&nbsp;&nbsp;&nbsp;1. <b>{{updateStudentClassChangeError.oldClassName}}</b>{{ 's' | translate }}
                <b>{{updateStudentClassChangeError.structureName}}</b> {{ 'and' | translate }}
                <b>{{updateStudentClassChangeError.newClassName}}</b>{{ 's' | translate }}
                <b>{{updateStudentClassChangeError.structureName}}</b> {{ 'feesAreNotMatching' | translate }}
              </div>
              <div>&nbsp;&nbsp;&nbsp;2. <b>{{studentName}}</b> {{ 'alreadyPaid' | translate }} <b>{{schoolCurrency}}
                  {{updateStudentClassChangeError.paidAmount}}</b></div>
            </div>
            <div style="text-align: left;">{{ 'ifYouStillWantToMove' | translate }} <b>{{studentName}}</b> {{ 'to' | translate }}
              <b>{{updateStudentClassChangeError.newClassName}}</b>,&nbsp; {{ 'pleaseCancel/deleteHisFeeFromFeeCollectionAndThenChangeTheClass' | translate }}
            </div>
          </div>
          <div class="col-md-12 text-center" style="padding:10px 0px;">
            <button class="btn btn-info btn-sm" (click)="closeFeesNotification()">{{ 'revert' | translate }}</button>
          </div>
        </div>
      </div>
      <div [ngStyle]="{'display': showClassChangeWarning ? 'none' : 'block'}" class="modal-footer">
        <button [disabled]="profileIsLoading" class="btn btn-primary active" type="button" data-dismiss="modal"
          (click)="popupOkAction()">{{button_text}}</button>
        <button type="button" class="btn btn-primary active" data-dismiss="modal" (click)="close()">{{ 'cancel' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Profile pic Modal popup -->
<div class="modal fade delete-profile-pic" id="deletePopup" tabindex="-1" role="dialog"
  aria-labelledby="simpleModalLabel" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog">
    <div class="modal-content col-md-12" style=" padding: 0;">
      <div class="modal-body" style="padding: 0;">
        <h3 style="cursor: pointer;text-align: right; margin-top: 0rem;" data-dismiss="modal" id="deletePopupClose"><i
            class="fa fa-close"></i></h3>
        <p style="margin-left: 15px;"> {{ 'areYouSureYouWantToDeleteProfilePicture' | translate }}</p>
        <div class="modal-footer">
          <button *ngIf="!removeStudentProfilePicStatus" class="btn btn-primary active"
            (click)="removeStudentProfilePic()">{{ 'yes' | translate }}</button>
          <button type="button" class="btn btn-primary active" data-dismiss="modal">{{ 'no' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /////// -->